export default class templateSelector {
    constructor() {
        return {
            restrict: 'E',
            scope: {
                event: '=',
                isSogetiAccount: '='
            },
            template: require('../../../../views/event/directives/template-selector.html'),
            controller: EventTemplateCtrl,
            controllerAs: 'template'
        }
    }
};

class EventTemplateCtrl {
    constructor($scope, $filter, SweetAlert, Event, Template, Sogeti) {
        this._scope = $scope;
        this._translator = $filter('translate');

        this.templateRepo = Template;
        this.eventRepo = Event;
        this.alerter = SweetAlert;
        this.sogeti = Sogeti;

        this.event = this._scope.event;
        this.isSogetiAccount = this._scope.isSogetiAccount;
        this.setup();

        this._scope.$on('event:templates:topic_changed', (event, data) => {
            this.event = data.event;
            this.isSogetiAccount = true;

            this.setup(data.topicId);
        });
    }

    setup(topicId) {
        this.show = true;

        if (this.isSogetiAccount) {
            this.getTemplatesByType(topicId);
        } else {
            this.eventTypeId = 4;

            this.templateRepo.allByType(this.eventTypeId).then((templates) => {
                this.activeTemplates = templates;
            });
        }
    }

    getTemplatesByType(topicId) {
        let topicToUse = topicId ? topicId : this.event.metadata.data.topic;

        this.templateRepo.allByType(topicToUse).then((templates) => {
            this.activeTemplates = templates.data.filter((template) =>
                this.sogeti.templateHasAllRequiredImages(template)
                && this.sogeti.templateHasAllRequiredBlocks(template.html)
            );
        });
    };

    setTemplate(template) {
        this.alerter.swal({
            title: this._translator('EVENT:FLASH:SELECT_TEMPLATE_HEADER'),
            text: this._translator('EVENT:FLASH:SELECT_TEMPLATE_BODY'),
            type: 'info',
            showCancelButton: true,
            cancelButtonText: this._translator('GLOBAL:NO'),
            confirmButtonText: this._translator('GLOBAL:YES')
        }, (isConfirm) => {
            if (isConfirm) {
                this.event['metadata']['data'].template_id = template.id;
                this.show = false;

                this.eventRepo.saveMetadata(this.event).then((event) => {
                    this._scope.$emit('event:template:selected', { event: event.data });
                });
            }
        });
    };

    backToEvent() {
        this.eventRepo.find(this.event.id).then((event) => {
            this.show = false;
            this._scope.$emit('event:templates:closed', { event: event.data });
        });
    };

    togglePreview(event, index) {
        event.preventDefault();
        event.stopPropagation();

        this.showPreview = ! this.showPreview;
        $('body').css('overflow-y', this.showPreview ? 'hidden' : 'inherit');

        if (this.showPreview) {
            $('#previewBox').html(decodeURIComponent(escape(this.activeTemplates[index].html)));
        }
    };
}
